<i18n src="@/locales/views/service_provider/tech_visit/query/list_tech_visits.yml" lang="yaml" ></i18n>
<template>
  <div>
    <div
      ref="spTechVisitsQueryMap"
      class="sm:rounded-lg"
      style="height: 400px; z-index: 0"
    ></div>
    <div class="text-center mt-4" v-if="show_crop_fields">
      <p class="text-sm text-gray-600 flex justify-center items-center space-x-4">
        <span class="flex items-center">
          <img
            src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png"
            alt="Marcador celeste"
            class="w-4 h-7 mr-2"
          />
          {{ $t('labels.tech_visits') }}
        </span>
        <span class="flex items-center">
          <img
            src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png"
            alt="Marcador verde"
            class="w-4 h-7 mr-2"
          />
          {{ $t('labels.crop_fields') }}
        </span>
      </p>
    </div>
  </div>
</template>

<script setup>
import L from "leaflet";
import { defineProps, onMounted, ref } from "vue";

const props = defineProps({
  techVisits: { type: Array },
  cropFields: { type: Array, default() { return [] } },
  showCropFields: { type: Boolean, default: false },
});

const tech_visits = ref(props.techVisits);
const crop_fields = ref(props.cropFields);
const show_crop_fields = ref(props.showCropFields);
const map = ref();
const spTechVisitsQueryMap = ref();
const markers = ref([]);

const setDefaultView = () => {
  let def_tech_visit = tech_visits.value[0];
  if (!def_tech_visit) return;

  map.value = L.map(spTechVisitsQueryMap.value).setView(
    [def_tech_visit.latitude, def_tech_visit.longitude],
    13
  );
};

const addTileLayer = () => {
  if (!map.value) return;

  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map.value);
};

const addMarkers = () => {
  if (!map.value) return;

  tech_visits.value.forEach(tech_visit => {
    let marker = L.marker([tech_visit.latitude, tech_visit.longitude], {
      title: tech_visit.crop_field.name
    }).addTo(map.value);
    markers.value.push(marker);
  });
};

var greenIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const addCropFieldsMarkers = () => {
  if (!map.value) return;

  crop_fields.value.forEach(crop_field => {
    let marker = L.marker([crop_field.latitude, crop_field.longitude], {
      title: crop_field.name,
      icon: greenIcon
    }).addTo(map.value);
    markers.value.push(marker);
  });
};

onMounted(() => {
  setDefaultView();
  addTileLayer();
  addMarkers();
  if (props.showCropFields) addCropFieldsMarkers();
});
</script>

<style scoped>
.leaflet-pane {
  z-index: 0 !important;
}

.leaflet-tile-pane {
  z-index: 0 !important;
}
.leaflet-overlay-pane {
  z-index: 0 !important;
}
.leaflet-shadow-pane {
  z-index: 0 !important;
}
.leaflet-marker-pane {
  z-index: 0 !important;
}
.leaflet-tooltip-pane {
  z-index: 0 !important;
}
.leaflet-popup-pane {
  z-index: 0 !important;
}

.leaflet-map-pane canvas {
  z-index: 0 !important;
}
.leaflet-map-pane svg {
  z-index: 0 !important;
}
</style>
